// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visibilContent {
    display: block;
    max-width: 90%;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    padding-bottom: 0.5em;
    cursor: auto;
    animation: fadeInContainer 0.5s 1 linear;
}

.hiddenContent {
    animation: fadeOutGlobal 1s;
    display: none;
}

.contentHelpContainer {
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-align: center;
    background-color: var(--DarkBlue);
    padding: 0.1rem;
    border-radius: 5px;
    -webkit-tap-highlight-color: transparent;
}

.contentHelpContainerLeftAnimation {
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-align: center;
    background-color: var(--DarkBlue);
    padding: 0.1rem;
    border-radius: 5px;
    -webkit-tap-highlight-color: transparent;
    animation: moveLeftGlobal 1s;
}

.contentHelpContainerRightAnimation {
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-align: center;
    background-color: var(--DarkBlue);
    padding: 0.1rem;
    border-radius: 5px;
    -webkit-tap-highlight-color: transparent;
    animation: moveRightGlobal 1s;
}

.contentHelpContainerLeftAnimation h4 {
    text-decoration: underline;
}

.contentHelpContainerRightAnimation h4 {
    text-decoration: underline;
}

.contentHelpContainer h4 {
    text-decoration: underline;
}

.contentHelpContainerLeftAnimation span {
    color: white;
}

.contentHelpContainerRightAnimation span {
    color: white;
}

.contentHelpContainer span {
    color: white;
}

.contentHelpContainerLeft {
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-align: left;
    background-color: var(--DarkBlue);
    padding: 0.1rem;
    border-radius: 5px;
    -webkit-tap-highlight-color: transparent;
}

.contentHelpContainerLeft h4 {
    text-decoration: none;
    padding-left: 1em;
}

.contentHelpContainerLeft span {
    color: white;
}

.contentHelpContainerLeft img {
    max-width: 1.2em;
    padding-right: 0.5em;
    padding-left: 0.3em;
}

.contentHelpContainerLeft:hover {
    background-color: var(--LiterGrayBlue);
}

.greenTitle {
    color: var(--HighlightBlue);
}

.contentHelpContainerLeftGreen {
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-align: left;
    background-color: var(--HighlightBlue);
    padding: 0.1rem;
    border-radius: 5px;
}

.contentHelpContainerLeftGreen h4 {
    text-decoration: none;
    padding-left: 1em;
}

.contentHelpContainerLeftGreen span {
    color: white;
}

.contentHelpContainerLeftGreen img {
    max-width: 1.2em;
    padding-right: 0.5em;
    padding-left: 0.3em;
}

.contentHelpContainerLeftGreen:hover {
    background-color: var(--LiterGrayBlue);
}

@keyframes fadeInContainer {
    0% {
        /* Safari & Chrome */
        -webkit-opacity: 0;
        -webkit-height: 0px;

        /* Firefox */
        -moz-opacity: 0;
        -moz-height: 0px;

        /* Internet Explorer */
        -ms-opacity: 0;
        -ms-height: 0px;

        /* Opera */
        -o-opacity: 0;
        -o-height: 0px;

        opacity: 0;
        height: 0px;
    }

    50% {
        /* Safari & Chrome */
        -webkit-opacity: 0;
        -webkit-height: 3em;

        /* Firefox */
        -moz-opacity: 0;
        -moz-height: 3em;

        /* Internet Explorer */
        -ms-opacity: 0;
        -ms-height: 3em;

        /* Opera */
        -o-opacity: 0;
        -o-height: 3em;

        opacity: 0;

        height: 3em;
    }

    90% {
        /* Safari & Chrome */
        -webkit-opacity: 0;

        /* Firefox */
        -moz-opacity: 0;

        /* Internet Explorer */
        -ms-opacity: 0;

        /* Opera */
        -o-opacity: 0;

        opacity: 0;
    }

    100% {
        /* Safari & Chrome */
        -webkit-opacity: 1;
        -webkit-height: auto;

        /* Firefox */
        -moz-opacity: 1;
        -moz-height: auto;

        /* Internet Explorer */
        -ms-opacity: 1;
        -ms-height: auto;

        /* Opera */
        -o-opacity: 1;
        -o-height: auto;

        opacity: 1;
        height: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ContentTextContainer/ContentTextContainer.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;;QAEnB,YAAY;QACZ,eAAe;QACf,gBAAgB;;QAEhB,sBAAsB;QACtB,cAAc;QACd,eAAe;;QAEf,UAAU;QACV,aAAa;QACb,cAAc;;QAEd,UAAU;QACV,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;;QAEnB,YAAY;QACZ,eAAe;QACf,gBAAgB;;QAEhB,sBAAsB;QACtB,cAAc;QACd,eAAe;;QAEf,UAAU;QACV,aAAa;QACb,cAAc;;QAEd,UAAU;;QAEV,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;;QAElB,YAAY;QACZ,eAAe;;QAEf,sBAAsB;QACtB,cAAc;;QAEd,UAAU;QACV,aAAa;;QAEb,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,oBAAoB;;QAEpB,YAAY;QACZ,eAAe;QACf,iBAAiB;;QAEjB,sBAAsB;QACtB,cAAc;QACd,gBAAgB;;QAEhB,UAAU;QACV,aAAa;QACb,eAAe;;QAEf,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".visibilContent {\n    display: block;\n    max-width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: left;\n    padding-bottom: 0.5em;\n    cursor: auto;\n    animation: fadeInContainer 0.5s 1 linear;\n}\n\n.hiddenContent {\n    animation: fadeOutGlobal 1s;\n    display: none;\n}\n\n.contentHelpContainer {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    text-align: center;\n    background-color: var(--DarkBlue);\n    padding: 0.1rem;\n    border-radius: 5px;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.contentHelpContainerLeftAnimation {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    text-align: center;\n    background-color: var(--DarkBlue);\n    padding: 0.1rem;\n    border-radius: 5px;\n    -webkit-tap-highlight-color: transparent;\n    animation: moveLeftGlobal 1s;\n}\n\n.contentHelpContainerRightAnimation {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    text-align: center;\n    background-color: var(--DarkBlue);\n    padding: 0.1rem;\n    border-radius: 5px;\n    -webkit-tap-highlight-color: transparent;\n    animation: moveRightGlobal 1s;\n}\n\n.contentHelpContainerLeftAnimation h4 {\n    text-decoration: underline;\n}\n\n.contentHelpContainerRightAnimation h4 {\n    text-decoration: underline;\n}\n\n.contentHelpContainer h4 {\n    text-decoration: underline;\n}\n\n.contentHelpContainerLeftAnimation span {\n    color: white;\n}\n\n.contentHelpContainerRightAnimation span {\n    color: white;\n}\n\n.contentHelpContainer span {\n    color: white;\n}\n\n.contentHelpContainerLeft {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    text-align: left;\n    background-color: var(--DarkBlue);\n    padding: 0.1rem;\n    border-radius: 5px;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.contentHelpContainerLeft h4 {\n    text-decoration: none;\n    padding-left: 1em;\n}\n\n.contentHelpContainerLeft span {\n    color: white;\n}\n\n.contentHelpContainerLeft img {\n    max-width: 1.2em;\n    padding-right: 0.5em;\n    padding-left: 0.3em;\n}\n\n.contentHelpContainerLeft:hover {\n    background-color: var(--LiterGrayBlue);\n}\n\n.greenTitle {\n    color: var(--HighlightBlue);\n}\n\n.contentHelpContainerLeftGreen {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    text-align: left;\n    background-color: var(--HighlightBlue);\n    padding: 0.1rem;\n    border-radius: 5px;\n}\n\n.contentHelpContainerLeftGreen h4 {\n    text-decoration: none;\n    padding-left: 1em;\n}\n\n.contentHelpContainerLeftGreen span {\n    color: white;\n}\n\n.contentHelpContainerLeftGreen img {\n    max-width: 1.2em;\n    padding-right: 0.5em;\n    padding-left: 0.3em;\n}\n\n.contentHelpContainerLeftGreen:hover {\n    background-color: var(--LiterGrayBlue);\n}\n\n@keyframes fadeInContainer {\n    0% {\n        /* Safari & Chrome */\n        -webkit-opacity: 0;\n        -webkit-height: 0px;\n\n        /* Firefox */\n        -moz-opacity: 0;\n        -moz-height: 0px;\n\n        /* Internet Explorer */\n        -ms-opacity: 0;\n        -ms-height: 0px;\n\n        /* Opera */\n        -o-opacity: 0;\n        -o-height: 0px;\n\n        opacity: 0;\n        height: 0px;\n    }\n\n    50% {\n        /* Safari & Chrome */\n        -webkit-opacity: 0;\n        -webkit-height: 3em;\n\n        /* Firefox */\n        -moz-opacity: 0;\n        -moz-height: 3em;\n\n        /* Internet Explorer */\n        -ms-opacity: 0;\n        -ms-height: 3em;\n\n        /* Opera */\n        -o-opacity: 0;\n        -o-height: 3em;\n\n        opacity: 0;\n\n        height: 3em;\n    }\n\n    90% {\n        /* Safari & Chrome */\n        -webkit-opacity: 0;\n\n        /* Firefox */\n        -moz-opacity: 0;\n\n        /* Internet Explorer */\n        -ms-opacity: 0;\n\n        /* Opera */\n        -o-opacity: 0;\n\n        opacity: 0;\n    }\n\n    100% {\n        /* Safari & Chrome */\n        -webkit-opacity: 1;\n        -webkit-height: auto;\n\n        /* Firefox */\n        -moz-opacity: 1;\n        -moz-height: auto;\n\n        /* Internet Explorer */\n        -ms-opacity: 1;\n        -ms-height: auto;\n\n        /* Opera */\n        -o-opacity: 1;\n        -o-height: auto;\n\n        opacity: 1;\n        height: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
